export default __webpack_public_path__ + "static/media/h1-icon.547d55ff.svg";